import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  line-height: 1.5;

  .confirm-withdraw-account__subtitle {
    font-size: 1.75rem;
    color: var(--blue00);
    text-align: center;
  }

  .confirm-withdraw-account__account-container {
    display: flex;
    flex-direction: column;

    width: fit-content;
    margin: 0 auto;
  }

  .confirm-withdraw-account__account-row {
    text-transform: uppercase;

    font-size: 1.25rem;
  }

  .confirm-withdraw-account__account-b {
    font-weight: 600;
  }
`
